<div class="insight-container" [ngClass]="getStatusClass(insightTitle)">
    <h1 class="insight-title">{{ insightTitle }}</h1>

    <p class="insight-description">
        {{ insightInfo }}
    </p>
</div>
